class FSStoreFinder {
  constructor(container) {
    this.container = container;
    this.input = container.querySelector('.fs-store-finder__search-input');
    this.list = container.querySelector('.fs-store-finder__list');
    this.items = container.querySelectorAll('.fs-store-finder__item');
    this.noResults = container.querySelector('.fs-store-finder__no-results');
    this.countEl = container.querySelector('.fs-store-finder__count');
    
    this.totalCount = this.items.length;
    
    this.init();
  }
  
  init() {
    if (!this.input || !this.list) return;
    
    this.input.addEventListener('input', this.handleSearch.bind(this));
    this.updateCount(this.totalCount);
  }
  
  handleSearch(e) {
    const query = e.target.value.toLowerCase().trim();
    let visibleCount = 0;
    
    this.items.forEach(item => {
      const storeName = item.textContent.toLowerCase();
      const matches = !query || storeName.includes(query);
      
      item.classList.toggle('fs-store-finder__item--hidden', !matches);
      
      if (matches) visibleCount++;
    });
    
    this.noResults.classList.toggle('fs-store-finder__no-results--visible', visibleCount === 0);
    this.updateCount(visibleCount);
  }
  
  updateCount(count) {
    if (this.countEl) {
      this.countEl.textContent = `Showing ${count} of ${this.totalCount} stores`;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.fs-store-finder').forEach(el => {
    new FSStoreFinder(el);
  });
});